import React from 'react';
import { ListItem as ListItemNew } from './ListItem';
import { convertOldListItemProps } from './converter.old';
import type { OldListItemProps } from './converter.old';

export type ListItemProps<T extends string = string> = OldListItemProps<T>;

export const ListItem = <T extends string>(props: ListItemProps<T>) => (
  <ListItemNew {...convertOldListItemProps(props)} />
);
